import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../ThemeContext';
import ComingSoonToast from './ComingSoonToast';
import './Hero.css';

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
    <path d="M16.4 12.5c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.1-2.8.8-3.5.8s-1.8-.8-3-.8c-1.5 0-2.9.9-3.7 2.3C3.2 12.3 4.3 17 6 19.6c.8 1.3 1.8 2.7 3.1 2.7s1.7-.8 3.2-.8 1.9.8 3.2.8 2.2-1.3 3-2.6c1-1.5 1.4-3 1.4-3.1-.1 0-2.5-1-2.5-3.8zM14.1 5.1c.7-.8 1.1-2 1-3.1-1 0-2.2.7-2.9 1.5-.6.7-1.2 1.9-1.1 3 1.1.1 2.2-.6 3-1.4z" />
  </svg>
);

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M5 3l14 9-14 9V3z" />
  </svg>
);

const ACTIVITIES = ['walks', 'meals', 'naps', 'treats', 'potty breaks', 'vet visits', 'medications', 'weigh-ins', 'playdates'];

const FADE_UP = { hidden: { opacity: 0, y: 6 }, visible: { opacity: 1, y: 0 } };
const STAGGER = { hidden: {}, visible: { transition: { staggerChildren: 0.09, delayChildren: 0.05 } } };
const T = { duration: 0.48, ease: [0.22, 1, 0.36, 1] };

const Hero = () => {
  useTheme();
  const [toast, setToast] = useState(false);

  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(() => setToast(false), 3000);
    return () => clearTimeout(id);
  }, [toast]);

  const showToast = () => setToast(true);

  return (
    <>
      {/* ── HERO ──────────────────────────────────── */}
      <motion.section className="hero" variants={STAGGER} initial="hidden" animate="visible">
        <motion.div className="eyebrow hero-eyebrow" variants={FADE_UP} transition={T}>For everyday dog parents</motion.div>
        <motion.h1 className="hero-heading" variants={FADE_UP} transition={T}>
          Every walk. Every meal.<br />
          <em>Every paw print.</em>
        </motion.h1>
        <motion.p className="hero-body" variants={FADE_UP} transition={T}>
          A calm little app for the rituals of dog life. Log the day quickly,
          then forget about it. We'll remember the rest.
        </motion.p>
        <motion.div className="store-buttons" variants={FADE_UP} transition={T}>
          <button className="store-btn" onClick={showToast}>
            <AppleIcon />
            <span>
              <span className="store-eyebrow">Download on the</span>
              <span className="store-name">App Store</span>
            </span>
          </button>
          <button className="store-btn" onClick={showToast}>
            <PlayIcon />
            <span>
              <span className="store-eyebrow">Get it on</span>
              <span className="store-name">Google Play</span>
            </span>
          </button>
        </motion.div>
      </motion.section>

      {/* ── RIBBON ────────────────────────────────── */}
      <div className="ribbon" aria-hidden="true">
        <div className="ribbon-track">
          {[...ACTIVITIES, ...ACTIVITIES].map((w, i) => (
            <span key={i} className="ribbon-item">
              {w}
              <span className="ribbon-dot" />
            </span>
          ))}
        </div>
      </div>

      <ComingSoonToast message="Coming soon!" isVisible={toast} />
    </>
  );
};

export default Hero;
